import "./Contact.scss";
import React, { useState } from "react";
import emailjs from "emailjs-com";
import { Form, Input } from "semantic-ui-react";
import Swal from "sweetalert2";
import Li from "../../assets/Icons/Logo/li.svg";
import Calendly from "../../assets/Icons/Logo/calendly.svg";
import Gmail from "../../assets/Icons/Logo/gmail.svg";

const SERVICE_ID = "service_nx3ears";
const TEMPLATE_ID = "template_zic0bn4";
const USER_ID = "OIDomCLqL_JyUPkO3";

const Contact = () => {
  const [formStatus, setFormStatus] = useState("");

  const handleOnSubmit = (e) => {
    e.preventDefault();
    setFormStatus("");
    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, e.target, USER_ID).then(
      (result) => {
        console.log(result.text);
        setFormStatus("Thanks, your message was sent.");
        Swal.fire({
          icon: "success",
          title: "Message Sent Successfully",
        });
      },
      (error) => {
        console.log(error.text);
        setFormStatus("Something went wrong. Please try again.");
        Swal.fire({
          icon: "error",
          title: "Ooops, something went wrong",
          text: error.text,
        });
      }
    );
    e.target.reset();
  };

  return (
    <section className="contact" id="contact">
      <h2 className="contact-header reveal">Connect with me</h2>
      <div className="contact-networks reveal">
        <div className="contact-networks__wrapper">
          <a
            href="https://www.linkedin.com/in/william-hoare/"
            target="_blank"
            rel="noreferrer"
          >
            <img className="contact-linkedin" src={Li} alt="Li" />
          </a>
        </div>
        <div className="contact-networks__wrapper">
          <a href="mailto:williamhoare@gmail.com">
            <img className="contact-gmail" src={Gmail} alt="GitHub" />
          </a>
        </div>
        <div className="contact-networks__wrapper">
          <a
            href="https://calendly.com/williamhoare"
            target="_blank"
            rel="noreferrer"
          >
            <img className="contact-calendly" src={Calendly} alt="Calendly" />
          </a>
        </div>
      </div>
      <div className="contact-networks__text reveal">
        <p className="contact-title">Linkedin</p>
        <p className="contact-title">Gmail</p>
        <p className="contact-title">Calendly</p>
      </div>
      <Form className="contact-form reveal" onSubmit={handleOnSubmit}>
        <Form.Field
          id="form-input-control-email"
          control={Input}
          name="user_email"
          placeholder="Email"
          required
          icon="mail"
          iconPosition="left"
        />
        <Form.Field
          id="form-input-control-last-name"
          control={Input}
          name="user_name"
          placeholder="Name"
          required
          icon="user circle"
          iconPosition="left"
        />
        <textarea
          id="form-textarea-control-opinion"
          name="user_message"
          placeholder="Message"
          required
        />
        <button type="submit" className="key-button">
          <span className="profile-button__text">Submit</span>
        </button>
        <p className="contact-form__status" role="status" aria-live="polite">
          {formStatus}
        </p>
      </Form>
    </section>
  );
};

export default Contact;
